import styled from 'styled-components';
import Image from 'next/image';
import { useContext } from 'react';
import { DarkModeContext } from '@/pages/_app';

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 2.5rem;
  border-top: 1px solid rgb(0, 0, 0);
  justify-content: space-evenly;
  align-items: center;
  position: fixed;
  bottom: 0;
`;

const Link = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
`;

const Share = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.5rem;
`;

const Item = styled.div`
  flex: 1;
`;

export default function Footer() {
  const { darkMode, setDarkMode } = useContext(DarkModeContext);
  function toggleDarkMode() {
    setDarkMode(darkMode === 'light' ? 'dark' : 'light');
  }
  function backGroundColour() {
    return darkMode === 'light'
      ? { backgroundColor: '#faf1e7' }
      : { backgroundColor: '#a9a8a8' };
  }

  function handleShare() {
    navigator.share
      ? navigator
          .share({
            url: 'https://nevillegoddard.vercel.app',
            text: `Neville Goddard's teachings`,
            title: 'Neville Goddard',
          })
          .then(function () {
            console.log('Successful share');
          })
          .catch(function (error) {
            window.open(
              'https://twitter.com/intent/tweet?text=Built%20this%20Neville%20Goddard%20teachings%20app%20including%20a%20GPT-3%20affirmations%20creation%20tool&url=https%3A%2F%2Fnevillegoddard.vercel.app',
              '_blank'
            );
          })
      : window.open(
          'https://twitter.com/intent/tweet?text=Built%20this%20Neville%20Goddard%20teachings%20app%20including%20a%20GPT-3%20affirmations%20creation%20tool&url=https%3A%2F%2Fnevillegoddard.vercel.app',
          '_blank'
        );
  }

  return (
    <Container style={backGroundColour()}>
      {/* <Item>
        <Link
          target="_blank"
          rel="noreferrer"
          href="https://t.me/neville_goddard_discussions"
        >
          <Image
            src="/images/telegram.png"
            width="30"
            height="30"
            alt="Telegram"
            priority
          />
        </Link>
      </Item> */}
      <Item>
        <Link
          target="_blank"
          rel="noreferrer"
          href="https://www.youtube.com/channel/UCFsoAP8qQAwtJWx4FYG03eQ"
        >
          <Image
            src="/images/youtube.png"
            width="30"
            height="30"
            alt="YouTube"
            priority
          />
        </Link>
      </Item>
      {/* <Item>
        <Link
          target="_blank"
          rel="noreferrer"
          href="https://twitter.com/@rich_shipping"
        >
          <Image
            src="/images/twitter.png"
            width="25"
            height="25"
            alt="Twitter"
            priority
            className="pointer"
          />
        </Link>
      </Item> */}
      <Item>
        <Share>
          <Image
            src="/images/share-icon.svg"
            width="25"
            height="25"
            alt="Share"
            priority
            className="pointer"
            onClick={() => handleShare()}
          />
        </Share>
      </Item>
      <Item>
        <Share>
          <Image
            src="/images/dark-mode.png"
            width="25"
            height="25"
            alt="Dark mode"
            priority
            className="pointer"
            onClick={() => toggleDarkMode()}
          />
        </Share>
      </Item>
    </Container>
  );
}
